<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Factors & Advantages Page" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Title *"
                  v-model="title"
                  :error="!!errors.factorsadvantages_title"
                  :error-messages="errors.factorsadvantages_title"
                  @input="delete errors.factorsadvantages_title"
                />
                <va-input
                  label="Subtitle"
                  v-model="subTitle"
                  :error="!!errors.factorsadvantages_subtitle"
                  :error-messages="errors.factorsadvantages_subtitle"
                  @input="delete errors.factorsadvantages_subtitle"
                />
                <div style="margin-bottom: 15px;">
                  <span>Content</span>
                  <ckeditor v-model="content" :editor="editor" :config="editorConfig"></ckeditor>
                  <div v-if="errors.factorsadvantages_content" style="color: red;">{{ errors.factorsadvantages_content[0] }}</div>
                </div>
                <va-card class="mb-3" title="Image">
                  <div v-if="imageExisting">
                    <a style="display: block;" target="_blank" :href="imageExisting"><img style="max-width: 400px;" :src="imageExisting"></a>
                    <div><va-button small color="danger" @click="imageExisting = deleteImage(imageId, 'factorsadvantages_image') ? '' : imageExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.factorsadvantages_image"
                    v-model="image"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('factorsadvantages_image', 'factorsadvantages_image', image[0])">Завантажити</va-button>
                  <div v-if="errors.factorsadvantages_image" style="color: red;">{{ errors.factorsadvantages_image[0] }}</div>
                </va-card>
                <va-input
                  label="SEO Title"
                  v-model="seoTitle"
                  :error="!!errors.factorsadvantages_seo_title"
                  :error-messages="errors.factorsadvantages_seo_title"
                  @input="delete errors.factorsadvantages_seo_title"
                />
                <va-input
                  label="SEO Description"
                  type="textarea"
                  v-model="seoDescription"
                  :error="!!errors.factorsadvantages_seo_description"
                  :error-messages="errors.factorsadvantages_seo_description"
                  @input="delete errors.factorsadvantages_seo_description"
                />
                <va-input
                  label="SEO OpenGraph Title"
                  v-model="seoOpenGraphTitle"
                  :error="!!errors.factorsadvantages_seo_ogtitle"
                  :error-messages="errors.factorsadvantages_seo_ogtitle"
                  @input="delete errors.factorsadvantages_seo_ogtitle"
                />
                <va-input
                  type="textarea"
                  label="SEO OpenGraph Description"
                  v-model="seoOpenGraphDescription"
                  :error="!!errors.factorsadvantages_seo_ogdescription"
                  :error-messages="errors.factorsadvantages_seo_ogdescription"
                  @input="delete errors.factorsadvantages_seo_ogdescription"
                />
                <va-card class="mb-3" title="SEO OpenGraph Image">
                  <div v-if="seoOpenGraphImageExisting">
                    <a style="display: block;" target="_blank" :href="seoOpenGraphImageExisting"><img style="max-width: 400px;" :src="seoOpenGraphImageExisting"></a>
                    <div><va-button small color="danger" @click="seoOpenGraphImageExisting = deleteImage(seoOpenGraphImageId, 'factorsadvantages_seo_ogimage') ? '' : seoOpenGraphImageExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.factorsadvantages_seo_ogimage"
                    v-model="seoOpenGraphImage"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('factorsadvantages_seo_ogimage', 'factorsadvantages_seo_ogimage', seoOpenGraphImage[0])">Завантажити</va-button>
                  <div v-if="errors.factorsadvantages_seo_ogimage" style="color: red;">{{ errors.factorsadvantages_seo_ogimage[0] }}</div>
                </va-card>
                <va-button
                  @click="validate()"
                >Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'
import '@ckeditor/ckeditor5-build-classic/build/translations/uk'

export default {
  name: 'grid',
  components: {
    ckeditor: CKEditor.component,
  },
  data () {
    return {
      title: '',
      subTitle: '',
      content: '',
      image: [],
      imageId: '',
      imageExisting: '',

      seoTitle: '',
      seoDescription: '',
      seoOpenGraphTitle: '',
      seoOpenGraphDescription: '',
      seoOpenGraphImage: [],
      seoOpenGraphImageId: '',
      seoOpenGraphImageExisting: '',

      errors: [],

      editor: ClassicEditor,
      editorConfig: {
        language: 'uk',
        simpleUpload: {
          uploadUrl: `${process.env.VUE_APP_AGRO_API_URL}/admin/editor/upload`,
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        },
      },

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
    putData () {
      return {
        factorsadvantages_title: this.title,
        factorsadvantages_subtitle: this.subTitle,
        factorsadvantages_content: this.content,

        factorsadvantages_seo_title: this.seoTitle,
        factorsadvantages_seo_description: this.seoDescription,
        factorsadvantages_seo_ogtitle: this.seoOpenGraphTitle,
        factorsadvantages_seo_ogdescription: this.seoOpenGraphDescription,
      }
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (param, key, file, agg = 'responsibility') {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append(param, file)
      formData.append('lang', this.locale)
      formData.append('aggregate', agg)
      formData.append('key', key)
      formData.append('multiple', '0')
      formData.append('file_id', '0')
      axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/upload/7?lang=${this.locale}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id, fieldKey) {
      return axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/7/delete-file/${id}?lang=${this.locale}`, {
        key: fieldKey,
      })
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/7?lang=${this.locale}`, this.putData)
        .then(response => {
          this.showToast('Successful update')
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }
          this.showToast('Error')
        })
    },
    validate () {
      axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/validate/7?lang=${this.locale}`, this.putData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response => {
          this.errors = response.data
          if (!Object.keys(this.errors).length) {
            this.submit()
          }
        })
        .catch(error => {
          console.log(error)
          this.showToast('Validate Fetch Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_AGRO_API_URL}/admin/pages/7?lang=${this.locale}`)
        .then(response => {
          this.title = response.data.factorsadvantages_title
          this.subTitle = response.data.factorsadvantages_subtitle
          this.content = response.data.factorsadvantages_content
          this.imageExisting = response.data.factorsadvantages_image ? process.env.VUE_APP_AGRO_ADMIN + response.data.factorsadvantages_image : null
          this.imageId = response.data.factorsadvantages_image_id

          this.seoTitle = response.data.factorsadvantages_seo_title
          this.seoDescription = response.data.factorsadvantages_seo_description
          this.seoOpenGraphTitle = response.data.factorsadvantages_seo_ogtitle
          this.seoOpenGraphDescription = response.data.factorsadvantages_seo_ogdescription
          this.seoOpenGraphImageExisting = response.data.factorsadvantages_seo_ogimage ? process.env.VUE_APP_AGRO_ADMIN + response.data.factorsadvantages_seo_ogimage : null
          this.seoOpenGraphImageId = response.data.factorsadvantages_seo_ogimage_id
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
